import React from "react";

export default function VideoBG({ type }) {
  return (
    <div
      style={{
        opacity: 0,
        animation: "0.5s forwards fadeIn",
        animationDelay: "0.3s",
        position: "absolute",
        zIndex: "0",
        height: "100%",
        width: "100%",
        left: "26px",
        top: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // backgroundSize: "cover",
        // transform: "translateX(-240px)",
        // background:
        //   "url('./images/simulator/iot-bg.jpg') no-repeat fixed center",
      }}
    >
      <video
        src={
          type === "iot-video" ? "./video/iot-hd.mp4" : "./video/uei-new.mp4"
        }
        className="fullvideo-iot"
        style={{
          //   position: "absolute",
          //   zIndex: 0,
          //   minWidth: "100%",
          //   minHeight: "100%",
          //   left: "0",
          //   top: 0,
          position: "absolute",
          left: "50%" /* % of surrounding element */,
          top: "50%",
          transform:
            type === "iot-video"
              ? "translate(-51%, -50%) rotateY(180deg)"
              : "translate(-50%, -50%)" /* % of current element //was at -47% Y switched to 50% Y for tablet view */,
        }}
        muted
        autoPlay
        playsInline
        loop={false}
      />
    </div>
  );
}
